const newslettercolumn = [
  {
    key: "num",
    label: "SN.",
  },
  {
    key: "email",
    label: "Email",
  },
  {
    key: "date",
    label: "Date",
  },
];

export { newslettercolumn };
